import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";

interface FormErrorProps {
  message?: string;
  autoHide?: boolean; // Optional prop to enable or disable auto-hide
  hideDelay?: number; // Delay time in milliseconds, defaults to 5000 (5 seconds)
}

export const FormError = ({ message, autoHide = true, hideDelay = 5000 }: FormErrorProps) => {
  const [visible, setVisible] = useState(Boolean(message));

  // Effect to set a timeout to hide the error message after a delay
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (message && autoHide) {
      setVisible(true);
      timer = setTimeout(() => {
        setVisible(false);
      }, hideDelay);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [message, autoHide, hideDelay]);

  // If there's no message or it's hidden, don't render anything
  if (!message || !visible) return null;

  return (
    <div className="bg-destructive/15 p-3 rounded-md flex flex-row items-center gap-x-2 text-sm text-destructive">
      <ExclamationTriangleIcon className="h-4 w-4" />
      {message}
    </div>
  );
};
